import React, { useEffect, useState } from "react";

import { updateFn } from "../shared/events";

export const Checkbox = (props) => {
    const [value, setValue] = useState((props.defaultValue ? props.defaultValue : props.value) || "");

    useEffect(() => {
        setValue((props.defaultValue ? props.defaultValue : props.value) || "");
    }, [props.defaultValue, props.value]);

    const onClick = (e) => {
        setValue(!e.currentTarget.value);
    };

    const handleEnter = (e) => {
        if (e.which === 13 || e.keyCode === 13) {
            if (props.updateOnChange) {
                props.updateOnChange(props.name, !e.currentTarget.value);
            } else {
                setValue(!e.currentTarget.value);
            }
        }
    };

    return (
        <div className={`form-field -checkbox ${props.classes}`}>
            <input
                type="checkbox"
                id={props.name}
                name={props.name}
                checked={props.value}
                disabled={props.disabled}
                hidden={props.invisible}
                required={props.required}
                value={value}
                onChange={props.onChange}
                onBlur={props.onBlur || updateFn(props.updateOnBlur)}
                onClick={props.onClick || updateFn(props.updateOnChange) || onClick}
                onKeyPress={handleEnter}
            />
            {props.name && props.label && <label htmlFor={props.name}>{props.label}</label>}
        </div>
    );
};

Checkbox.defaultProps = {
    value: false,
    classes: "",
};
